import StepCard from './StepCard';
import type { HowItWorksProps } from './useHowItWorks';

const HowItWorksDesktop = ({ data }: HowItWorksProps) => {
  return (
    <section
      id="how-it-works"
      className="flex flex-col items-center gap-15 bg-surface-card px-20 py-25"
    >
      <div className="flex max-w-[600px] flex-col items-center gap-4 text-center">
        <span className="font-body text-sm font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-5xl font-medium text-foreground-primary">
          {data.title}
        </h2>
      </div>

      <div className="grid w-full grid-cols-3 gap-12">
        {data.steps.map((step) => (
          <StepCard key={step.id} step={step} />
        ))}
      </div>
    </section>
  );
};

export default HowItWorksDesktop;
